import { useQuery } from "@tanstack/react-query";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { commonQueryOptions } from "../utils/tanstack-query-helpers";
import type { Creator } from "../types/creative-eval";

export function useCreativeEvalCreators(brandId: number | null) {
  return useQuery<Creator[]>({
    queryKey: ["creative-eval-creators", brandId],
    queryFn: () => fetcher<Creator[]>(`${RelativeUrl}/creative-eval/creators?brand_id=${brandId}`),
    enabled: brandId !== null,
    ...commonQueryOptions.stable
  });
}
